var _defs, _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "phone_svg__phone",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 797.19 787.52"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "@keyframes flash-ani-01{0%{opacity:0}20%{opacity:1}}@keyframes flash-ani-02{0%{opacity:0}40%{opacity:1}}@keyframes flash-ani-03{0%{opacity:0}60%{opacity:1}}.phone_svg__cls-1{fill:#fff}.phone_svg__rect-01,.phone_svg__rect-02,.phone_svg__rect-03{animation-duration:3s;animation-iteration-count:infinite;animation-timing-function:step-end}.phone_svg__rect-01{animation-name:flash-ani-01}.phone_svg__rect-02{animation-name:flash-ani-02}.phone_svg__rect-03{animation-name:flash-ani-03}.phone_svg__delay{animation-delay:.4s}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "phone_svg__cls-1 phone_svg__rect-01",
    d: "M136.7 672.65l14.8 8.6v-4.1l-14.8-8.6v4.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "phone_svg__cls-1 phone_svg__rect-02",
    d: "M154.6 683.05l13.8 8v-4.1l-13.8-8v4.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "phone_svg__cls-1 phone_svg__rect-03",
    d: "M170.9 692.45l19.5 11.3v-4.1l-19.5-11.3v4.1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "phone_svg__cls-1 phone_svg__rect-01 phone_svg__delay",
    d: "M151.4 726.85l3.6 2v-4.1l-3.6-2v4.1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "phone_svg__cls-1 phone_svg__rect-02 phone_svg__delay",
    d: "M157.2 730.15l3.5 2.1v-4.1l-3.5-2.1v4.1z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "phone_svg__cls-1 phone_svg__rect-03 phone_svg__delay",
    d: "M162.9 733.45l3.6 2.1v-4.1l-3.6-2.1v4.1z"
  })));
}

export default SvgPhone;